module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAOElEQVQ4y2NgGBTgPxJgKDr2/722LhiD2PjAIDIApBAZIxuAF8MATAOpmHoGUOyFYRCNlKeDIQ0A8CzTtnNNhyMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/FO.png
// module id = 1140
// module chunks = 0